import styled from "styled-components";

export const CreateInventoryWorkOrderWrapper = styled.div`
.errored-row {
  background: #D950404A !important;
}
i.anticon.anticon-down.ant-select-arrow-icon {
  width: 20px;
  margin-left: auto;
}
span.bag-icon-gated.new-gated{
  background-color: #D95040 !important;
}
.additional-note-input{
    margin-top: 8px;
}
.card-wrapper {
    display: grid;
    grid-template-columns: 1fr 4fr;
    grid-gap: 8px;
    align-items: center;
}
.edit-able-data {
    display: flex;
    align-items: center;
    grid-gap: 8px;
}
.error-msg{
    p{
        color:#D95040 !important;
    }
}
.items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
      label{
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      text-align: left;
      color:${({ theme }) => theme['body-text-color']};
      }
      p{
        margin: 0px;
        padding: 7px 12px;
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        background: ${({ theme }) => theme['table-header-color']};
        border-radius: 2px;
        &.wear-house-name{
          width: 292px;
        }
      }
    }
.postion-relative.search.work-order-search-bar {
    width: 300px;
}
.edit-able-data svg {
    cursor: pointer;
    color: #1665d8;
}
header{
  border-radius: 6px;
  padding: 16px;
  border: 1px solid #E0E0E0;
  display: flex;
  flex-direction: column;
  grid-row-gap:12px;
  div{
    margin: 0;
  }
  .inputs{
    input{
    height: 32px;
    }
  }
  .select2-container{
    margin: 0;
    div#react-select-2-placeholder {
    position: relative;
    top: 0;
}
  }
}
.two-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme['table-text']};
    height: 34px;
}
.not-gated-icon-wrapper {
    display: flex;
    align-items: center;
    grid-gap: 4px;
    span.bag-icon-gated {
    background: #009C34;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    padding: 1px 8px;
    color: #fff;
    border-radius: 2px;
    user-select: none;
    &.gated-error{
        color: red;
        background-color: transparent;
        font-weight: 600;
    }
}
svg {
    color: #1565D8;
    cursor: pointer;
}
}
.ag-header-cell.ag-header-cell-sortable.parent-header.ag-focus-managed::after {
    display: none;
}
.ag-header-cell.parent-header.ag-focus-managed::after {
    display: none;
}
span.ag-header-group-text {
    color: #616980;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
}
.expired-data-wrapper {
    display: flex;
    flex-direction: column;
    span {
    font-size: 10px;
    font-weight: 300;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #7E8A90;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
p {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
    color: #535E63;
}
}

svg.delete-icon {
    color: #D95040;
    font-size: 16px;
    cursor: pointer;
}
section{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0px 16px;
  h6{
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${({theme}) => theme['primary-color']};
  margin: 0;
  }
}
.ag-selection-checkbox {
    margin-right: 6px !important;
}
.ag-labeled.ag-label-align-right.ag-checkbox.ag-input-field.ag-header-select-all {
    margin-right: 0px !important;
    margin-left: 5px;
}
span.ag-cell-wrapper.ag-cell-expandable.ag-row-group {
    padding: 0px;
    height: 27px;
    min-height: 27px;
}
.ag-cell {
    &:not(:last-child){
      border-right: 1px solid #eff1f5 !important;
    }
}
.parent-header-stock span.ag-header-group-text {
    margin: auto;
}
`;

export const InnerTableWrapper = styled.div`
*{
  font-family: "Titillium Web", sans-serif;
}
.ag-cell.ag-cell-not-inline-editing.ag-cell-normal-height.ag-cell-value {
    border-right: 1px solid ${({ theme }) => theme['border-color']};
}
button{
  margin: auto;
  margin-bottom: 0px;
}
 .ag-header-cell{
  &::after {
    background-color: #E6E6E6;
    border-right: none;
    height: 100px;
    top: 0;
}
 }
 .identifier-text-wrapper {
    display: flex;
    flex-direction: column;
    span {
    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #7E8A90;
    user-select: all;
    pointer-events: all;
}
p {
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #535E63;
}
}
.ag-cell.ag-cell-not-inline-editing.ag-cell-normal-height.ag-cell-value {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #535E63;
}
`
export const AddSkuDrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;

  .ag-center-cols-viewport .ag-cell-wrapper {
      height: 100%;
      min-height: 31px !important;
  }
  .ag-cell {
      &:not(:last-child){
        border-right: 1px solid #eff1f5 !important;
      }
  }
  .side-actions {
      display: flex;
      grid-gap: 16px;
  }

  .switch-tab-wrapper {
      display: flex;
      align-items: center;
      grid-gap: 4px;
      background: #fff;
      box-shadow: 0px 0px 25px 0px #0000001A;
      padding: 5px 12px;
      border-radius: 4px;
      .switch-tab {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: #212121;
      white-space: nowrap;
  }
  .switch-count {
  color: #1565D8;
  font-weight: 400;
  font-size: 10px;
  line-height: 18px;
  vertical-align: middle;
  border: 1px solid #1565D8;
  padding: 1px 2px;
  border-radius: 12px;
  min-width: 22px;
  display: flex;
  justify-content: center;
  margin-right: 8px;
  }
  }
  span.bag-icon-gated.new-gated{
    background-color: #D95040 !important;
  }
  .edit-able-data {
      display: flex;
      align-items: center;
      grid-gap: 8px;
  }
  .edit-able-data svg {
      cursor: pointer;
      color: #1665d8;
  }
  .card-wrapper {
      display: grid;
      grid-template-columns: 1fr 4fr;
      grid-gap: 8px;
      align-items: center;
  }
  .two-line-ellipsis {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      text-align: left;
      color: ${({ theme }) => theme['table-text']};
      height: 34px;
  }
  header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      flex-shrink: 0;
      div{
          &:not(:first-child){
          max-width: 426px;
          width: 100%;
      }
      }
      .back-icon{
      display: flex;
      grid-gap: 12px;
      align-items: center;
       span {
      font-size: 18px;
      font-weight: 600;
      line-height: 18px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      margin: 0;
      color: #1565D8;
  }
   svg {
      font-size: 20px;
      color: #1565D8;
      cursor: pointer;
  }
  }
  }
  .drawer-body {
    margin-bottom: 24px;

    .add-sku-drawer-loading {
      width: 100%;
      
      .sku-table {
        margin-top: 0 !important;
      }
    }
  }
  .drawer-footer {
    flex-shrink: 0;
    padding-top: 24px;
    border-top: 1px solid #E0E0E0;
    margin-top: auto;
  }
  .error-msg {
    p {
      color: #D95040 !important;
    }
  }
  svg.delete-icon {
    color: #D95040;
    font-size: 16px;
    cursor: pointer;
  }
  .not-gated-icon-wrapper {
      display: flex;
      align-items: center;
      grid-gap: 4px;
      span.bag-icon-gated {
      background: #009C34;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      padding: 1px 8px;
      color: #fff;
      border-radius: 2px;
      user-select: none;
  }
  svg {
      color: #1565D8;
      cursor: pointer;
  }
  }
`;

export const BulkExpiryContentWrapper = styled.div`
ul{
    padding: 0;
    display: flex;
    flex-direction: column;
    min-width: 100px;
    li{
        display: flex;
        align-items: center;
        grid-gap: 8px;
        list-style: none;
        padding: 8px 12px;
        border-radius: 2px;
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        cursor: pointer;
        img{
            width: 14px;
        }
        &.delete{
            svg{
                color: red;
            }
            &:hover{
            background-color: #FFC9C9;
            span{
                color: #D95040;
            }
            }
        }
        &:hover{
        background: #F5F5F5;
        }
        svg{
            color: #1565D8;
        }
        span{
            font-size: 10px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;
            text-decoration-skip-ink: none;
            color: #4E5969;
        }
        svg{
            cursor: pointer;
        }
    }
}
`
export const AddressModalWrapper = styled.div`
h6{
    color: #1F1F1F;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0%;
    margin: 36px 0px 32px;
}
.address-modal-wrapper{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 24px 12px;
    & > div{
        margin: 0;
    }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`